/** @typedef {import("../../api/types").Order} Order */
import React from "react";
import {useLocation} from "react-router-dom";
import OrderForm from "./components/OrderForm";

const OrderNew = () => {
    // Set by "cancel and clone" on the order detail page.
    const cloneFrom = /** @type {Order|undefined} */ (useLocation().state?.cloneFrom);
    return <OrderForm cloneFrom={cloneFrom} />;
};

export default OrderNew;
